webpackJsonp([114276838955818,60335399758886],{

/***/ 109:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(221);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(109);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	module.exports = {
	  siteMetadata: {
	    title: 'Elohina Guevara',
	    author: 'Elohina Guevara',
	    description: 'Personal site'
	  },
	  pathPrefix: '/',
	  plugins: [{
	    resolve: 'gatsby-plugin-typography',
	    options: {
	      pathToConfigModule: 'src/utils/typography.js'
	    }
	  }, {
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      name: 'images',
	      path: __dirname + '/src/assets/images'
	    }
	  }, {
	    resolve: 'gatsby-plugin-google-fonts',
	    options: {
	      fonts: ['Noto Sans JP', 'sans-serif']
	    }
	  }, {
	    resolve: 'gatsby-transformer-remark',
	    options: {
	      plugins: [{
	        resolve: 'gatsby-remark-images',
	        options: {
	          maxWidth: 630,
	          withWebp: true
	        }
	      }, 'gatsby-remark-copy-linked-files']
	    }
	  }, {
	    resolve: 'gatsby-plugin-manifest',
	    options: {
	      name: 'Elohina Guevara',
	      short_name: 'Elohina',
	      start_url: '/',
	      background_color: '#924863',
	      theme_color: '#924863',
	      display: 'standalone',
	      icon: 'src/assets/images/elo.jpg',
	      lang: 'en-US'
	    }
	  }, 'gatsby-plugin-offline', 'gatsby-transformer-sharp', 'gatsby-plugin-sharp', 'gatsby-plugin-react-helmet', 'gatsby-plugin-sass']
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(1095);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(447);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(449);
	
	var _HelmetConstants = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(1110));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 1115:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(448);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyConfig = __webpack_require__(208);
	
	var _favicon = __webpack_require__(1115);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { name: "author", content: _gatsbyConfig.siteMetadata.author }),
	      _react2.default.createElement("meta", { name: "description", content: _gatsbyConfig.siteMetadata.description }),
	      _react2.default.createElement("link", { rel: "shortcut icon", href: _favicon2.default, type: "image/x-icon" }),
	      _react2.default.createElement(
	        "title",
	        null,
	        _gatsbyConfig.siteMetadata.title
	      ),
	      _react2.default.createElement("html", { lang: "en-US" })
	    ),
	    children()
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-02d7b4be04d9f574182f.js